<template>
  <div id="store-selector">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="お気に入り店舗" backUrl="/account/profile" />
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app></footer-app>
      <!-- identification -->
      <section>
        <div class="l-auth" :class="{'fade-base': true, 'fade': pageFade}">
          <div class="mb-32">
            <div class="l-auth__title">表示中の店舗</div>
            <div class="shop-item no-shadow">
              {{shopData && shopData.name}}
            </div>
          </div>
          <div class="l-auth__box">
            <div class="l-auth__title">お気に入り店舗</div>
            <div class="store-selector__shops mb-32">
              <shop-button v-for="(shop, index) in shopFollowsData" :noarrow="true" :selected="currentShopId == shop.id" :key="index" :shop_data="shop" :show_favorite="false" :onselect="onSelectShop" :onaccess="onAccessShop" :shop_follows="shop_follows" :onfavorite="onFavoriteShop" />
            </div>
            <div class="mb-32" v-if="shopFollowsData && !shopFollowsData.length">
              現在お気に入りされている店舗はありません
            </div>
            <div class="btn-tutorial mt-32 mx-auto mb-24 font-size-16" @click.prevent="selectOther">
              お気に入り店舗を追加する
            </div>
          </div>
        </div>
      </section>

      <div class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showModal" style=" z-index: 201;">
        <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="text-right" @click="closeModal()">
            <img src="/assets/images/icon/icon-close.svg" alt="" />
          </div>
          <div class="c-modal__dialog--center c-modal__content">
            <template>
              <div class="w-100 text-center">
                <img src="/assets/images/icon/icon-map-active.svg" class="mt-16" width="24" alt="" />
                <div class="mb-18 font-bold font-size-18 mt-13">{{ selectedShop && selectedShop.name }}</div>
                 <div class="mb-30 font-bold"> {{ selectedShop && selectedShop.address }} </div>
                <div class="pt-32 border-top font-size-18 content-modal-auth font-bold">表示店舗を変更しますか？</div>
                <div class="btn-tutorial mt-32 mx-auto mb-24 font-size-18" @click.prevent="changeShop">
                  表示店舗を変更する
                </div>
                <div class="mx-auto mb-30 font-size-14 select-other-shop" @click.stop="onFavoriteShop(selectedShop)">
                  お気に入り店舗登録を解除する
                  <svg width="16" height="11" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.37891 9.24194L5.62155 4.9993" stroke="#FF7777" stroke-linecap="round"/>
                    <path d="M1.37891 0.756958L5.62155 4.9996" stroke="#FF7777" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div> 
      <loader :loading="processingFollow" />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import PopAlert from "../components/PopAlert.vue";
import ShopButton from "../components/ShopButton.vue";
import { getShops, getShopFollows, updateShopFollows, getShop } from "../store/firestore";
import { AREA_DEF } from "../config/const";
import firebase from "../common/firebaseProject";
import TopBar from "../components/TopBar.vue";
import Loader from "../components/parts/loader.vue";

export default Vue.extend({
  name: "StoreFavorite",
  components: {
    'footer-app': Footer,
    PopAlert,
    ShopButton,
    TopBar,
    Loader
  },
  mixins: [Tenant],
  data() {
    return {
      AREA_DEF: AREA_DEF,
      shop_follows: undefined,
      shopFollowsData: undefined,
      showSelectAlert: false,
      currentShopId: this.$store.getters.shopId,
      shopData: undefined,
      showModal: false,
      processingFollow: false,
      selectedShop: undefined
    }
  },
  mounted() {
    Common.initDom();
  },
  async created() {
    this.shopData = await getShop(this.shopId);
    const shops = await getShops();
    const shop_follows = [];
    const shopFollowsData = [];
    const favoriteShopIds = await getShopFollows(this.$store.state.userId);
    Object.keys(shops).forEach(area => {
      this.sortCities(shops)[area].forEach(shop => {
        if (favoriteShopIds.indexOf(shop.id) != -1) {
          shop_follows.push(shop.id);
          shopFollowsData.push(shop);
        }
      })
    });
    this.shop_follows = shop_follows;
    this.shopFollowsData = shopFollowsData;
  },
  methods: {
    onSelectShop(shopData) {
      this.selectedShop = shopData;
      this.currentShopId = shopData.id;
      this.showModal = true;
    },
    onAccessShop(shopData) {
      this.$router.push(`/location/${shopData.id}`)
    },
    onCloseModal() {
      this.showSelectAlert = false;
    },
    changeShop() {
      this.$store.dispatch('setShopId', this.currentShopId).then(() => {
        this.$router.push('/top');
      });
    },
    selectOther() {
      this.$router.push('/account/selectstore')
    },
    async onFavoriteShop(shopData) {
      if (this.processingFollow) return;
      this.processingFollow = true;
      try {
        if (this.shop_follows.indexOf(shopData.id) != -1) {
          this.shop_follows = this.shop_follows.filter((elem) => elem != shopData.id);
          const callable = firebase.functions('asia-northeast1').httpsCallable('unsubscribeTopic');
          await callable({
            topicId: `follow-store-${shopData.id}`
          })
          await updateShopFollows(this.shop_follows, this.$store.state.userId);
        } else {
          const callable = firebase.functions('asia-northeast1').httpsCallable('subscribeTopic');
          await callable({
            topicId: `follow-store-${shopData.id}`
          })
          this.shop_follows.push(shopData.id);
          await updateShopFollows(this.shop_follows, this.$store.state.userId);
        }
        this.shopFollowsData = this.shopFollowsData.filter((elem) => elem.id != shopData.id);
        this.showModal = false;
      } catch (e) {
        console.log(e);
      }
      this.processingFollow = false;
    },
    closeModal() {
      this.showModal = false;
    },
    nextModal() {
      this.showModal = false;
      this.$router.push('/account/profile');
    }
  }
});
</script>